// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ChannelType } from "./channel-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * One endpoint within a multiplexed channel.
 */
export class ChannelEndpoint implements flatbuffers.IUnpackableObject<ChannelEndpointT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ChannelEndpoint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsChannelEndpoint(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelEndpoint,
  ): ChannelEndpoint {
    return (obj || new ChannelEndpoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsChannelEndpoint(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelEndpoint,
  ): ChannelEndpoint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ChannelEndpoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Human-readable label for this endpoint (optional).
   */
  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Failover/merge grouping index. FAILOVER channels must use group_id = 0.
   * MIXED channels use group_id to separate parallel failover legs.
   */
  groupId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Ascending priority within group_id (0 = primary, 1 = first failover…).
   * MERGE channels must use priority = 0 for all endpoints.
   */
  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * TCP/UDP socket address override for this endpoint (host:port).
   */
  vendorSocketAddress(): string | null;
  vendorSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  routableSocketAddress(): string | null;
  routableSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  routableSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  reportingSocketAddress(): string | null;
  reportingSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  reportingSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Serial device path override (e.g. /dev/ttyUSB0).
   */
  serialPath(): string | null;
  serialPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  serialPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Transport protocol for this endpoint; v1 validation rejects mixing
   * connection_type values across endpoints on the same channel.
   */
  connectionType(): ChannelType {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ChannelType.TCP;
  }

  baudRate(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 9600;
  }

  /**
   * Optional per-endpoint adapter override. When null, the bank's adapter_id
   * is used. Only valid in MERGE/MIXED modes; rejected in SINGLE/FAILOVER.
   */
  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Whether this endpoint may receive Control message writes at all.
   *
   * A merged channel often has one endpoint that is read-only from the
   * platform's perspective (a reporting or observer leg). Setting this false
   * excludes the endpoint from every routing outcome: `ControlRoute` targets
   * naming it are skipped, and it is never chosen by any
   * `ControlWriteMode` fallback. Additive trailing field — absent decodes as
   * true, preserving the pre-existing behaviour where any endpoint could be
   * written to.
   */
  controlWritable(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startChannelEndpoint(builder: flatbuffers.Builder) {
    builder.startObject(16);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, channelIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addGroupId(builder: flatbuffers.Builder, groupId: number) {
    builder.addFieldInt32(3, groupId, 0);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt32(4, priority, 0);
  }

  static addVendorSocketAddress(
    builder: flatbuffers.Builder,
    vendorSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, vendorSocketAddressOffset, 0);
  }

  static addRoutableSocketAddress(
    builder: flatbuffers.Builder,
    routableSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, routableSocketAddressOffset, 0);
  }

  static addReportingSocketAddress(
    builder: flatbuffers.Builder,
    reportingSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(7, reportingSocketAddressOffset, 0);
  }

  static addSerialPath(builder: flatbuffers.Builder, serialPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, serialPathOffset, 0);
  }

  static addConnectionType(builder: flatbuffers.Builder, connectionType: ChannelType) {
    builder.addFieldInt8(9, connectionType, ChannelType.TCP);
  }

  static addBaudRate(builder: flatbuffers.Builder, baudRate: number) {
    builder.addFieldInt32(10, baudRate, 9600);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, adapterIdOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(12, +active, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, updatedAtOffset, 0);
  }

  static addControlWritable(builder: flatbuffers.Builder, controlWritable: boolean) {
    builder.addFieldInt8(15, +controlWritable, +true);
  }

  static endChannelEndpoint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // channel_id
    return offset;
  }

  unpack(): ChannelEndpointT {
    return new ChannelEndpointT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.name(),
      this.groupId(),
      this.priority(),
      this.vendorSocketAddress(),
      this.routableSocketAddress(),
      this.reportingSocketAddress(),
      this.serialPath(),
      this.connectionType(),
      this.baudRate(),
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.active(),
      this.createdAt(),
      this.updatedAt(),
      this.controlWritable(),
    );
  }

  unpackTo(_o: ChannelEndpointT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.name = this.name();
    _o.groupId = this.groupId();
    _o.priority = this.priority();
    _o.vendorSocketAddress = this.vendorSocketAddress();
    _o.routableSocketAddress = this.routableSocketAddress();
    _o.reportingSocketAddress = this.reportingSocketAddress();
    _o.serialPath = this.serialPath();
    _o.connectionType = this.connectionType();
    _o.baudRate = this.baudRate();
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.active = this.active();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.controlWritable = this.controlWritable();
  }

  unpackFields(...fields: string[]): ChannelEndpointT {
    const t = new ChannelEndpointT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("group_id")) {
      t.groupId = this.groupId();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("vendor_socket_address")) {
      t.vendorSocketAddress = this.vendorSocketAddress();
    }
    if (fieldSet.has("routable_socket_address")) {
      t.routableSocketAddress = this.routableSocketAddress();
    }
    if (fieldSet.has("reporting_socket_address")) {
      t.reportingSocketAddress = this.reportingSocketAddress();
    }
    if (fieldSet.has("serial_path")) {
      t.serialPath = this.serialPath();
    }
    if (fieldSet.has("connection_type")) {
      t.connectionType = this.connectionType();
    }
    if (fieldSet.has("baud_rate")) {
      t.baudRate = this.baudRate();
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("control_writable")) {
      t.controlWritable = this.controlWritable();
    }
    return t;
  }
}

export class ChannelEndpointT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public channelId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public groupId: number = 0,
    public priority: number = 0,
    public vendorSocketAddress: string | Uint8Array | null = null,
    public routableSocketAddress: string | Uint8Array | null = null,
    public reportingSocketAddress: string | Uint8Array | null = null,
    public serialPath: string | Uint8Array | null = null,
    public connectionType: ChannelType = ChannelType.TCP,
    public baudRate: number = 9600,
    public adapterId: UuidT | null = null,
    public active: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public controlWritable: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.channelId === null || this.channelId === undefined) {
      throw new Error('Required field "channel_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const vendorSocketAddress =
      this.vendorSocketAddress !== null ? builder.createString(this.vendorSocketAddress!) : 0;
    const routableSocketAddress =
      this.routableSocketAddress !== null ? builder.createString(this.routableSocketAddress!) : 0;
    const reportingSocketAddress =
      this.reportingSocketAddress !== null ? builder.createString(this.reportingSocketAddress!) : 0;
    const serialPath = this.serialPath !== null ? builder.createString(this.serialPath!) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    ChannelEndpoint.startChannelEndpoint(builder);
    ChannelEndpoint.addId(builder, id);
    ChannelEndpoint.addChannelId(builder, channelId);
    ChannelEndpoint.addName(builder, name);
    ChannelEndpoint.addGroupId(builder, this.groupId);
    ChannelEndpoint.addPriority(builder, this.priority);
    ChannelEndpoint.addVendorSocketAddress(builder, vendorSocketAddress);
    ChannelEndpoint.addRoutableSocketAddress(builder, routableSocketAddress);
    ChannelEndpoint.addReportingSocketAddress(builder, reportingSocketAddress);
    ChannelEndpoint.addSerialPath(builder, serialPath);
    ChannelEndpoint.addConnectionType(builder, this.connectionType);
    ChannelEndpoint.addBaudRate(builder, this.baudRate);
    ChannelEndpoint.addAdapterId(builder, adapterId);
    ChannelEndpoint.addActive(builder, this.active);
    ChannelEndpoint.addCreatedAt(builder, createdAt);
    ChannelEndpoint.addUpdatedAt(builder, updatedAt);
    ChannelEndpoint.addControlWritable(builder, this.controlWritable);

    return ChannelEndpoint.endChannelEndpoint(builder);
  }

  clone(): ChannelEndpointT {
    const obj = new ChannelEndpointT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.name = this.name;
    obj.groupId = this.groupId;
    obj.priority = this.priority;
    obj.vendorSocketAddress = this.vendorSocketAddress;
    obj.routableSocketAddress = this.routableSocketAddress;
    obj.reportingSocketAddress = this.reportingSocketAddress;
    obj.serialPath = this.serialPath;
    obj.connectionType = this.connectionType;
    obj.baudRate = this.baudRate;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.active = this.active;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.controlWritable = this.controlWritable;
    return obj;
  }

  equals(other: ChannelEndpointT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.name !== other.name) return false;
    if (this.groupId !== other.groupId) return false;
    if (this.priority !== other.priority) return false;
    if (this.vendorSocketAddress !== other.vendorSocketAddress) return false;
    if (this.routableSocketAddress !== other.routableSocketAddress) return false;
    if (this.reportingSocketAddress !== other.reportingSocketAddress) return false;
    if (this.serialPath !== other.serialPath) return false;
    if (this.connectionType !== other.connectionType) return false;
    if (this.baudRate !== other.baudRate) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.active !== other.active) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.controlWritable !== other.controlWritable) return false;
    return true;
  }
}

export function verifyChannelEndpoint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "channel_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 22, 1);
    verifier.checkScalarField(tablePos, 24, 4);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 26);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 28, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 34, 1);
  } finally {
    verifier.popDepth();
  }
}
